import apiClient from './apiClient';

// P1's ONE consent key (D11). Shared constant so no form spells the string
// literal itself — the FE's key set must never drift from the catalogue's.
export const DIGITAL_RECORDS_KEY = 'digital_records';

/**
 * Consent catalogue API (CONSENT-CAPTURE P1).
 *
 * GET /api/organisation/settings/consents — server-owned catalogue: text +
 * version + default-checked state, per `## API CONTRACT` (architect-review.md).
 * The FE renders this text verbatim rather than holding a second hardcoded
 * copy, so the stored `version` always resolves to the text actually shown.
 *
 * Response: { version, consents: [{ key, label, text, default_granted, sort_order }] }
 */
export const getConsentCatalog = async () => {
  const res = await apiClient.get('/api/organisation/settings/consents');
  return res.data;
};

const consentApi = { getConsentCatalog };

export default consentApi;
